module.exports = __webpack_public_path__ + "media/images/illus_error-97b2997d0d8fda3753dea9ee9c9a5732.svg";